module.exports = __webpack_public_path__ + "static/forms-required-do-45c3cbec5538cc3c7607ef15fcf550a1.png";